import angular from 'angular';
import timeEntryInputComponent from './time-entry-input.component';

export default angular.module('timeEntryInput', []).component('timeEntryInput', timeEntryInputComponent);



// WEBPACK FOOTER //
// ./client/pages/timesheet/components/time-entry-input/time-entry-input.js